export const BLEED_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
} as const;

export interface BleedFile {
  id: number;
  file_name: string;
  mime_type: string | null;
  size: number | null;
  created_at: string;
  url: string;
}

export interface Bleed {
  id: number;
  uuid: string;
  code: string; // 5 dígitos, pode começar com zero
  bleed_date: string;
  value: string | number;
  observation: string | null;
  seller_id: number;
  unity_id: number | null;
  bleed_status_id: number;
  reviewed_at: string | null;
  review_observation: string | null;
  created_at: string;
  files_count?: number;
  files?: BleedFile[];
  seller?: { id: number; user?: { id: number; name: string } };
  unity?: { id: number; name: string } | null;
  bleed_status?: { id: number; name: string };
  reviewed_by?: { id: number; name: string } | null;
  created_by?: { id: number; name: string } | null;
}

export interface BleedSummary {
  current_balance: number;
  approved_count: number;
  approved_total: number;
  pending_count: number;
  pending_total: number;
}

export interface BleedListResponse {
  data: Bleed[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  summary: BleedSummary;
}
